import React from "react";
import { BrowserRouter as Router, Route, Routes ,useNavigate, useLocation } from "react-router-dom";
import {PrivateRoute} from "./PrivateRoute";
import {PublicRoutes} from "./PublicRoutes"
import { history } from "../utilities/RouterHelper";
import SplashScreen from "../screens/SplashScreen";
import Dashboard from "../screens/Dashboard";
import Profile from "../screens/Profile";
import Recharge from "../screens/Recharge";
import Statement from "../screens/Statement";
import Dispute from "../SubComponents/Disputes";
import ServiceRequest from "../SubComponents/ServiceRequest";
import SRfile from "../SubComponents/ServiceRequest/srFile";
import Help from "../screens/Help";
import PoolToTag_Home from "../screens/FundTransfer/PoolAccount_Home";
import UsedCarLoan from "../SubComponents/UsedCarLoan/Index";
import Services from "../screens/OtherServices";
import ActivateUser from "../screens/login/ActivateUser";
import CheckTagBalanceScreen from "../screens/login/CheckTagBalanceScreen";
import SelectUnlockScreen from "../screens/login/SelectUnlockScreen";
import UnlockUserScreen from "../screens/login/UnlockUserScreen";
import SelectForgotScreen from "../screens/login/SelectForgotScreen";
import ForgotUserScreen from "../screens/login/ForgotUserScreen";
import ForgotPasswordScreen from "../screens/login/ForgotPasswordScreen";
import ResponseScreen from "../screens/login/ResponseScreen";
import LoginByVrnScreen from "../screens/login/LoginByVrnScreen";
import LoginComponent from "../screens/login/LoginComponent";
import PoolAccount_Home from "../SubComponents/PoolAccount/PoolAccount_Home";
import CustomerDetails from "../SubComponents/Profile/CustomerDetails";
import FuelRecharge from "../SubComponents/Profile/FuelRecharge";
import TagDetails from "../SubComponents/Profile/TagDetails";
import MyVehicles from "../SubComponents/Profile/MyVehicles";
import Transfer_PoolToTag from "../SubComponents/PoolAccount/Transfer_PoolToTag";
import FT_Transfer_PoolToTag from "../screens/FundTransfer/Transfer_PoolToTag";
import Pool_AutoRecharge from "../SubComponents/PoolAccount/Pool_AutoRecharge";
import PoolToTag from "../SubComponents/PoolAccount/PoolToTag";
import FT_PoolToTag from "../screens/FundTransfer/PoolToTag";
import ChangeAcType from "../SubComponents/PoolAccount/ChangeAcType";
import FT_ChangeAcType from "../screens/FundTransfer/ChangeAcType";
import PoolToTagTransferSummary from "../SubComponents/PoolAccount/PoolToTagTransferSummary";
import FT_PoolToTagTransferSummary from "../screens/FundTransfer/PoolToTagTransferSummary";
import PoolSelectVehicles from "../SubComponents/PoolAccount/PoolSelectVehicles";
import FT_PoolSelectVehicles from "../screens/FundTransfer/PoolSelectVehicles";
import AddVehicle from "../SubComponents/Profile/AddVehicle";
import VehicleDetails from "../SubComponents/Profile/VehicleDetails";
import AutoRecharge from "../SubComponents/Profile/AutoRecharge";
import RCUpdate from "../SubComponents/ServiceRequest/RCUpdate";
import KycUpdate from "../SubComponents/ServiceRequest/KycUpdate"
import SelectVehicleForCloseTag from "../SubComponents/ServiceRequest/SelectVehicleForCloseTag";
import MobileNumberUpdate from "../SubComponents/ServiceRequest/MobileNumberUpdate";
import TagClosure from "../SubComponents/ServiceRequest/TagClosure";
import TripInsurance from "../SubComponents/TripInsurance";
import AllignedServices from "../SubComponents/MaxPro/index"
// import SrDetails from "../SubComponents/ServiceRequest/SrDetails.web";
import TripCreateRaiseDispute from "../SubComponents/TripInsurance/TripCreateRaiseDispute";
import UpdateKyv from "../SubComponents/Profile/UpdateKyv.web"

const AppNavigation = (props) => {
  // init custom history object to allow navigation from 
    // anywhere in the react app (inside or outside components)
    history.navigate = useNavigate();

    const url = window.location.pathname.split('/');
    global.activeScreen = url[1]?.toLowerCase()
    
  return (
  
      <Routes>
        
        <Route path="/" element={<SplashScreen />} />
        <Route path="/Login" element={<PublicRoutes><LoginComponent /></PublicRoutes>} />
        <Route path="/LoginByVrnScreen" element={ <PublicRoutes> <LoginByVrnScreen /></PublicRoutes>}/>
        <Route path="/ResponseScreen" element={<PublicRoutes><ResponseScreen /></PublicRoutes>} />
        <Route path="/ActivateUser" element={<PublicRoutes><ActivateUser /></PublicRoutes>} />
        <Route path="/UnlockUserScreen" element={<PublicRoutes><UnlockUserScreen /></PublicRoutes>} />
        <Route path="/SelectUnlockScreen" element={<PublicRoutes><SelectUnlockScreen /></PublicRoutes>} />
        <Route path="/CheckTagBalance" element={<PublicRoutes><CheckTagBalanceScreen /></PublicRoutes>} />
        <Route path="/SelectForgotScreen" element={ <PublicRoutes> <SelectForgotScreen /></PublicRoutes>}/>
        <Route path="/ForgotUserScreen" element={ <PublicRoutes> <ForgotUserScreen /></PublicRoutes>}/>
        <Route path="/ForgotPasswordScreen" element={ <PublicRoutes> <ForgotPasswordScreen /></PublicRoutes>}/>

        <Route path="/home/*" element={<PrivateRoute> <Dashboard /></PrivateRoute>}/>
        <Route path="/dashboard" element={<PrivateRoute> <Dashboard /></PrivateRoute>}/>
        <Route path="/help" element={ <PrivateRoute> <Help /></PrivateRoute>}/>
        <Route path="/Profile" element={ <PrivateRoute> <Profile /></PrivateRoute>}>
          <Route path="" element={ <PrivateRoute> <CustomerDetails /></PrivateRoute>} />
          <Route path="PoolAccount" element={ <PrivateRoute> <PoolAccount_Home /></PrivateRoute>}>
            <Route path="TransferPool" element={ <PrivateRoute> <Transfer_PoolToTag /></PrivateRoute>} />
            <Route path="AutoRecharge" element={ <PrivateRoute> <Pool_AutoRecharge /></PrivateRoute>} />
            <Route path="PoolToTag" element={ <PrivateRoute> <PoolToTag /></PrivateRoute>} />
            <Route path="ChangeManual" element={ <PrivateRoute> <ChangeAcType /></PrivateRoute>} />
            <Route path="transferSummary" element={ <PrivateRoute> <PoolToTagTransferSummary /></PrivateRoute>} />
            <Route path="PoolSelection" element={ <PrivateRoute> <PoolSelectVehicles /></PrivateRoute>} />
          </Route>
          <Route path="Fuel" element={ <PrivateRoute> <FuelRecharge /></PrivateRoute>} />
          <Route path="TagDetails" element={ <PrivateRoute> <TagDetails /></PrivateRoute>} />
          <Route path="MyVehicles" element={ <PrivateRoute> <MyVehicles /></PrivateRoute>} > 
             <Route path="" element={ <PrivateRoute> <MyVehicles /></PrivateRoute>} /> 
             <Route path="VehicleDetails" element={ <PrivateRoute> <VehicleDetails /></PrivateRoute>} />
             <Route path="AutoRecharge" element={ <PrivateRoute> <AutoRecharge /></PrivateRoute>} />
             <Route path="UpdateKYV" element={ <PrivateRoute> <UpdateKyv /></PrivateRoute>} />
             {/* <Route path="AddVehicle" element={ <PrivateRoute> <AddVehicle /></PrivateRoute>} /> */}
          </Route>
         
        </Route>
        <Route path="Transfer" element={ <PrivateRoute>  <PoolToTag_Home /></PrivateRoute>} >
            <Route path="TransferPool" element={ <PrivateRoute> <FT_Transfer_PoolToTag /></PrivateRoute>} />
            <Route path="PoolToTag" element={ <PrivateRoute> <FT_PoolToTag /></PrivateRoute>} />
            <Route path="PoolSelection" element={ <PrivateRoute> <FT_PoolSelectVehicles /></PrivateRoute>} />
            <Route path="transferSummary" element={ <PrivateRoute> <FT_PoolToTagTransferSummary /></PrivateRoute>} />
            <Route path="ChangeManual" element={ <PrivateRoute> <FT_ChangeAcType /></PrivateRoute>} />
            {/* <Route path="AutoRecharge" element={ <PrivateRoute> <FT_Pool_AutoRecharge /></PrivateRoute>} /> */}
        </Route>
        <Route path="/Statement" element={ <PrivateRoute> <Statement /></PrivateRoute>}/>
        <Route path="/Recharge" element={ <PrivateRoute> <Recharge /></PrivateRoute>}/>
        <Route path="/Transfer" element={ <PrivateRoute> <PoolToTag_Home /></PrivateRoute>}/>
        <Route path="/Dispute" element={ <PrivateRoute> <Dispute /></PrivateRoute>}/>
        <Route path="/OtherServices" element={ <PrivateRoute> <Services /></PrivateRoute>}>
          <Route path="" element={ <PrivateRoute> <TripInsurance /></PrivateRoute>}/>
          <Route path="insurance" element={ <PrivateRoute> <TripInsurance /></PrivateRoute>}/>
          <Route path="UsedCarLoan" element={ <PrivateRoute> <UsedCarLoan /></PrivateRoute>}/>
          <Route path="maxpro" element={ <PrivateRoute> <AllignedServices /></PrivateRoute>}/> 
          <Route path="dispute" element={ <PrivateRoute> <TripCreateRaiseDispute /></PrivateRoute>}/>   
        </Route>
        <Route path="/ServiceRequest" element={<PrivateRoute><SRfile /></PrivateRoute>}>
          <Route path="" element={ <PrivateRoute> <ServiceRequest /></PrivateRoute>} />
          <Route path="RcUpdate" element={ <PrivateRoute> <RCUpdate /></PrivateRoute>} />
          <Route path="KycUpdate" element={ <PrivateRoute> <KycUpdate /></PrivateRoute>} />
          <Route path="SelectVehicleForTagClosure" element={ <PrivateRoute> <SelectVehicleForCloseTag /></PrivateRoute>} />
          <Route path="TagClosure" element={ <PrivateRoute> <TagClosure /></PrivateRoute>} />
          <Route path="MobileUpdate" element={ <PrivateRoute> <MobileNumberUpdate /></PrivateRoute>} />
          {/* <Route path="details" element={ <PrivateRoute> <SrDetails /></PrivateRoute>} /> */}
        </Route>  

        <Route path="*" element={<SplashScreen />} />                             
      </Routes>
   
  );
};

export default AppNavigation;
